import backgroundImg from './../../../../assets/images/ev-owners-hero.jpg';
import { Box, Typography } from '@mui/material';
import LinkCardSet from '../../../../components/linkCard/LinkCardSet';
import Icon from '../../../../components/icon/Icon';
import { useIntl } from 'react-intl';

export default function BigPromise() {
  const { formatMessage } = useIntl();

  const LINK_CARDS = [
    {
      icon: <Icon variant="evRight" />,
      link: '#Incentives',
      title: formatMessage({ id: 'evOwners.intro.programs' }),
    },
    {
      icon: <Icon variant="chargingRoute" />,
      link: '#ChargerMap',
      title: formatMessage({ id: 'evOwners.intro.chargingRoute' }),
    },
    {
      icon: <Icon variant="rate" />,
      link: '#RateCheck',
      title: formatMessage({ id: 'evOwners.intro.rate' }),
    },
    {
      icon: <Icon variant="evRight" />,
      link: '#FindADealership',
      title: formatMessage({ id: 'evOwners.intro.upgrade' }),
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(0,0,0,.5)',
            textAlign: 'center',
            py: '120px',
            px: { xs: 3, sm: 5 },
            minHeight: '400px',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: 'white.100',
              textShadow: '2px 2px 3px hsl(0deg 0% 100% / 10%)',
            }}
          >
            {formatMessage({ id: 'evOwners.intro.headline' })}
          </Typography>
          <Typography
            variant="h4"
            mt="1.5rem"
            sx={{
              color: 'white.100',
              textShadow: '2px 2px 3px hsl(0deg 0% 100% / 10%)',
            }}
          >
            {formatMessage({ id: 'evOwners.intro.details' })}
          </Typography>
        </Box>
      </Box>
      <LinkCardSet mt="-70px" linkCards={LINK_CARDS} />
    </>
  );
}
